import type { BaseError } from 'wagmi'

/**
 *
 * @param mutations from tanQuery
 * @returns error message or "" if no error
 */
export function get_blockchain_error_message(
  mutations: { isReady: boolean; isError: boolean; error: Error | null }[],
): string {
  const q = mutations.find((m) => m.isReady && m.isError)
  if (q == null) return ''

  const { error } = q

  if (error == null) return 'unknown error'

  let message = (error as BaseError).shortMessage
  if (message == null) message = 'internal error'

  return message
}
